import { render, staticRenderFns } from "./AdUnit.vue?vue&type=template&id=1aba260c"
import script from "./AdUnit.vue?vue&type=script&lang=js"
export * from "./AdUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports